export default __webpack_public_path__ + "static/media/2.bfd41640.jpg";